import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { MouseEvent } from "react";

import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";
import { anchorClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface CoverImageOverlayProps {
  changeButtonText?: string;
  onChange?: (event: MouseEvent<HTMLButtonElement>) => void;
  onDelete?: (event: MouseEvent<HTMLButtonElement>) => void;
  removeButtonText?: string;
  removeButtonVariant?: "secondary" | "danger";
}

export const CoverImageOverlay = ({
  onChange,
  onDelete,
  changeButtonText,
  removeButtonText,
  removeButtonVariant = "secondary",
}: CoverImageOverlayProps) => {
  const { isViewOnlyMasquerading } = usePunditUserContext();
  return (
    <div
      className={classNames(
        anchorClassNames("cover-image-overlay"),
        "absolute top-0 flex size-full items-center justify-center space-x-2 bg-gray-800/20 opacity-0 transition-opacity duration-300 hover:opacity-100",
      )}
      data-testid="cover-image-overlay"
    >
      <Button
        variant="secondary"
        onClick={onChange}
        disabled={isViewOnlyMasquerading}
      >
        {changeButtonText}
      </Button>
      <Button
        variant={removeButtonVariant}
        onClick={onDelete}
        type="button"
        disabled={isViewOnlyMasquerading}
      >
        {removeButtonText}
      </Button>
    </div>
  );
};
